module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('CustomModal', {
    staticClass: "basic-modal",
    attrs: {
      "id": "report-content-modal",
      "title": _vm.$t('common.report'),
      "close-title": _vm.$t('common.cancel'),
      "ok-title": _vm.$t('common.confirmation'),
      "ok-busy": _vm.busy,
      "okDisabled": _vm.isDisabled
    },
    on: {
      "cancel": function($event) {
        return _vm.$emit('cancel')
      },
      "ok": function($event) {
        return _vm.reportContent()
      }
    }
  }, [_c('div', [_c('Radio', {
    attrs: {
      "id": "option-content-has-error",
      "model-value": _vm.reportIssue,
      "check-value": 1
    },
    on: {
      "change": _vm.onRadioSelect
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n        " + _vm._s(_vm.reportContentType.error) + "\n      ")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "id": "option-content-is-inappropriate",
      "model-value": _vm.reportIssue,
      "check-value": 2
    },
    on: {
      "change": _vm.onRadioSelect
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n        " + _vm._s(_vm.reportContentType.inappropriate) + "\n      ")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "id": "option-content-input-text",
      "model-value": _vm.reportIssue,
      "check-value": 3
    },
    on: {
      "change": _vm.onRadioSelect
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n        " + _vm._s(_vm.reportContentType.inputText) + "\n      ")])]), _vm._v(" "), (_vm.isReportInputText) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reportContentMessage),
      expression: "reportContentMessage"
    }],
    staticClass: "report-input-text",
    attrs: {
      "maxlength": "500",
      "rows": "10",
      "cols": "50"
    },
    domProps: {
      "value": (_vm.reportContentMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reportContentMessage = $event.target.value
      }
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56b2196a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReportContentModal.vue
// module id = 1578
// module chunks = 1